import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, CardActions, CardHeader, colors, Divider, Popover } from '@material-ui/core';

import { EmptyList, NotificationList } from './components';
import { createStructuredSelector } from 'reselect';
import { getAllNotificationsSelector } from '../../views/Notifications/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { getRolesSelector, getUserSelector, isLoggedInSelector } from '../../appContainer/selectors';
import { SUPERVISOR_MONITOR_ROLE_GROUP } from '../../utils/constants';
import { useInjectReducer } from '../../store/injectReducer';
import { NOTIFICATION_REDUCER_KEY } from '../../views/Notifications/constants';
import notificationsReducer from '../../views/Notifications/reducer';
import { useInjectSaga } from '../../store/injectSaga';
import notificationsSaga from '../../views/Notifications/saga';
import { setNotifIntervalAction } from '../../appContainer/actions';
import { useIntl } from 'react-intl';
import { CloseIcon } from '../../icons';

const useStyles = makeStyles(() => ({
  root: {
    width: 350,
    maxWidth: '100%',
  },
  actions: {
    backgroundColor: colors.grey[50],
    justifyContent: 'center',
  },
}));

const stateSelector = createStructuredSelector({
  notifications: getAllNotificationsSelector,
  loggedInUser: getUserSelector,
  roles: getRolesSelector,
  isLoggedIn: isLoggedInSelector,
});

const NotificationsPopover = props => {
  useInjectReducer({ key: NOTIFICATION_REDUCER_KEY, reducer: notificationsReducer });
  useInjectSaga({ key: NOTIFICATION_REDUCER_KEY, saga: notificationsSaga });

  const { anchorEl, ...rest } = props;
  const { notifications, roles, loggedInUser, isLoggedIn } = useSelector(stateSelector);
  const dispatch = useDispatch();
  const intl = useIntl();

  useEffect(() => {
    if (isLoggedIn) {
      setTimeout(() => {
        dispatch(setNotifIntervalAction.Trigger());
      }, 15000);
    }
  }, [isLoggedIn]);

  const userRole = (roles || {})[(loggedInUser || {}).role];
  const path = SUPERVISOR_MONITOR_ROLE_GROUP.includes(userRole) ? '/admin/notifications' : '/user/notifications';

  const classes = useStyles();

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}>
      <div className={classes.root}>
        <CardHeader title={intl.formatMessage({id: "topbar.notifications.popover.title", defaultMessage: "Notifications"})} action={<CloseIcon onClick={props.onClose}/>} />
        <Divider />
        {notifications.length > 0 ? <NotificationList notifications={notifications} path={path} onClose={props.onClose} /> : <EmptyList />}
        <Divider />
        <CardActions className={classes.actions}>
          <Button component={RouterLink} size="small" to={path} onClick={props.onClose}>
            {intl.formatMessage({id: "topbar.notifications.popover.seeall", defaultMessage: "See All"})}
          </Button>
        </CardActions>
      </div>
    </Popover>
  );
};

NotificationsPopover.propTypes = {
  anchorEl: PropTypes.any,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default NotificationsPopover;
